/* eslint-disable no-case-declarations */

import { SET_LANGUAGES } from '../actions/AppConfigsActions';
import {
  ADD_ENTITY_RESOLVER_RULES,
  ADD_TRANSLATIONS,
  BULK_TRANSLATE_STRING_LOAD_FAILED,
  BULK_TRANSLATE_STRING_PENDING,
  GET_SYSTEM_TRANSLATIONS,
  SET_TRANSLATED_STRING,
} from '../actions/TranslationActions';
import { toArray } from '../form-designer/utils/form-manager.utils';

export default (state = { isLoaded: false }, action) => {
  switch (action.type) {
    case ADD_TRANSLATIONS:
      const { translations } = action;
      const newFormTranslations = { ...translations.Form, ...(state.Form || {}) };
      const newEntityTranslations = { ...translations.Entity, ...(state.Entity || {}) };

      return {
        ...state,
        Form: newFormTranslations,
        Entity: newEntityTranslations,
      };
    case ADD_ENTITY_RESOLVER_RULES:
      if (action.entityResolverRules) {
        return {
          ...state,
          entityResolverRules: toArray(action.entityResolverRules),
        };
      }
      return state;
    case GET_SYSTEM_TRANSLATIONS:
      return {
        ...state,
        system: action.payload,
        cached: {},
      };
    case SET_TRANSLATED_STRING:
      return {
        ...state,
        cached: { ...state.cached, ...action.payload },
        isLoaded: true,
      };
    case SET_LANGUAGES:
      return {
        ...state,
        languages: action.payload,
      };
    case BULK_TRANSLATE_STRING_PENDING:
      return {
        ...state,
        isLoaded: false,
      };
    case BULK_TRANSLATE_STRING_LOAD_FAILED:
      return {
        ...state,
        isLoaded: true,
      };
    default:
      return state;
  }
};
